module.exports = __webpack_public_path__ + "assets/logo-thuiswinkel.6c045a77.svg";